import { useEffect, useRef, type RefObject } from 'react';

/**
 * Lint-safe alternative to `autoFocus`: returns a ref that focuses the
 * element on mount. Avoids the `jsx-a11y/no-autofocus` rule and the
 * accidental scroll-into-view behavior of the JSX prop on long pages.
 */
export function useFocusOnMount<E extends HTMLElement>(): RefObject<E | null> {
  const ref = useRef<E | null>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  return ref;
}
